import React from 'react';
import moment from 'moment';
import { useClient } from 'jsonapi-react';
import getIcon from '@/utils/getIcon';
import { useTranslation } from 'react-i18next';
import {
  NotificationItem,
  NotificationItemBody,
  NotificationItemDateTime,
  NotificationItemFooter,
  NotificationItemHeader,
  NotificationItemIcon,
  NotificationItemMore,
  NotificationItemText,
  NotificationItemTitle
} from '@/components/custom/notifications';
import { AvatarWrapper } from '@/components/ui/avatar';

export function NotificationsMessageItem(props) {
  const { t } = useTranslation();
  const { notification, notifications, setNotificationCount, setNotifications, notificationCount } = props;
  const client = useClient();
  moment.locale(t('language.language'));

  async function handleNotificationRead() {
    const { error } = await client.mutate('update_all/notifications', {
      notifications: notification['related-notification-ids'].map(id => ({ id: id, unread: false }))
    });

    if (!error) {
      setNotificationCount(notificationCount - 1);
      setNotifications(notifications.map(n => (n.id === notification.id ? { ...n, unread: false } : n)));
    }
    window.location.replace(notification?.url);
  }

  function senderNames() {
    let names = notification?.senders.map(sender => sender?.name).slice(0, 4);
    return notification?.senders?.length > 4 ? names.join(', ') : names.slice(0, -1).join(', ') + ' e ' + names.slice(-1);
  }

  return (
    <NotificationItem
      variant="center"
      read={!notification.unread}
      onClick={() => handleNotificationRead()}
    >
      <NotificationItemHeader>
        <NotificationItemIcon size="sm">{getIcon(notification.icon)}</NotificationItemIcon>
      </NotificationItemHeader>

      <div className="relative h-[60px] w-[60px]">
        {notification?.senders?.length == 1 ? (
          <AvatarWrapper
            size="md"
            src={notification?.senders[0]?.image?.url}
            text={notification?.senders[0]?.name}
            className="size-[60px] border border-white"
          />
        ) : (
          <>
            <AvatarWrapper
              size="sm"
              src={notification?.senders[0]?.image?.url}
              text={notification?.senders[0]?.name}
              className="absolute left-0 top-0 size-[40px] border border-white"
            />
            <AvatarWrapper
              size="sm"
              src={notification?.senders[1]?.image?.url}
              text={notification?.senders[1]?.name}
              className="absolute bottom-0 right-0 size-[40px] border border-white"
            />
          </>
        )}
      </div>

      <NotificationItemBody>
        <NotificationItemTitle>
          {notification?.senders?.length >= 2 ? senderNames() : notification?.senders[0]?.name}
          {notification?.senders?.length > 4 && <NotificationItemMore> +{notification?.senders?.length - 4}</NotificationItemMore>}
        </NotificationItemTitle>
        <NotificationItemText>
          {notification.body &&
            notification.body.split('*f6$').map((n, i) => {
              return n[0] == '>' ? (
                <a
                  href={notification.url}
                  key={i}
                >
                  {n.substring(1, n.length)}
                </a>
              ) : (
                n
              );
            })}
        </NotificationItemText>
      </NotificationItemBody>

      <NotificationItemFooter>
        <NotificationItemDateTime>{moment(notification['created-at']).fromNow()}</NotificationItemDateTime>
      </NotificationItemFooter>
    </NotificationItem>
  );
}
